export const looksLikeCjk = (text) => {
  const s = String(text ?? '');
  for (let i = 0; i < s.length; i += 1) {
    const code = s.charCodeAt(i);
    if ((code >= 0x4E00 && code <= 0x9FFF) || (code >= 0x3400 && code <= 0x4DBF)) {
      return true;
    }
  }
  return false;
};

export const fixMojibakeUtf8 = (value) => {
  if (value == null) return value;
  const text = String(value);
  if (!text) return text;

  // Only try the latin1->utf8 reinterpretation for strings that are entirely 0..255.
  for (let i = 0; i < text.length; i += 1) {
    if (text.charCodeAt(i) > 255) return text;
  }

  try {
    const bytes = new Uint8Array(text.length);
    for (let i = 0; i < text.length; i += 1) bytes[i] = text.charCodeAt(i);
    const decoded = new TextDecoder('utf-8').decode(bytes);
    return looksLikeCjk(decoded) ? decoded : text;
  } catch (_) {
    return text;
  }
};

